import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Child } from '@/types/child';

export const getChild = async (id: number): Promise<ApiResult<Child>> => {
  const { status, result } = await callApi<Child>(
    `children/${id}`,
    'GET',
    undefined,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
